import React, { useState } from "react";
import { useHistory } from "react-router";
import "./main-card.scss";

export interface MainCardProp {
    index: number;
    name: string;
    icon?: JSX.Element;
    link?: string;
    description?: string;
}

interface Props {
    items?: MainCardProp[],
}


const AppMainCard = (props: Props) => {

    const [selected, setSelected] = useState<MainCardProp | undefined>(undefined);
    const history = useHistory();

    const itemClick = (item: MainCardProp) => {
        setSelected(item);
        if (item && item.link) {
            history.push(item.link);
            setSelected(undefined);
        }
    }

    // const next = () => {
    //     if (selected && selected.link) {
    //         history.push(selected.link);
    //         setSelected(undefined);
    //     }
    // }

    return (
        <div className="main-card">
            <div>
                {props.items && props.items.map((item, index) => (
                    <div key={index} className={`card-item${selected?.index === item.index ? " active" : ""}`} onClick={() => { itemClick(item) }}>
                        {item.icon &&
                            <span className="card-icon">
                                {item.icon}
                            </span>
                        }
                        <div className="card-text">
                            <span>
                                {item.name}
                            </span>
                            {item.description &&
                                <small>
                                    {item.description}
                                </small>}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default AppMainCard